var map = {
	"./A_farm.png": 4764,
	"./B_farm.png": 1709,
	"./C_farm.png": 2666,
	"./D_farm.png": 7619,
	"./E_farm.png": 104,
	"./F_farm.png": 7337,
	"./G_farm.png": 9526,
	"./purpan_farm.png": 5467
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8044;